var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2924_38006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.482 13.7816L5.59844 12.2153L1.27148 26.4337L5.07309 24.5756L7.15509 28.0001L11.482 13.7816Z",
    fill: "url(#paint0_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73349 12.5179L6.40137 13.5595L8.44379 20.8216L10.7516 13.5871L6.73349 12.5179Z",
    fill: "url(#paint1_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70117 21.7382L8.87344 22.3515L11.4816 13.7815L11.2581 13.7227L8.70117 21.7382Z",
    fill: "#EAA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16887 12.3676L1.83105 26.1593L2.48367 25.8407L6.73302 12.5179L6.16887 12.3676Z",
    fill: "url(#paint2_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44347 20.8214L6.49805 26.9199L6.85888 27.5137L8.7011 21.7381L8.44347 20.8214Z",
    fill: "url(#paint3_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44336 20.8214L8.70099 21.7381L11.2579 13.7226L10.7512 13.5869L8.44336 20.8214Z",
    fill: "#BC5A1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.099 10.4223L6.18359 11.8783L9.96347 25.3194L12.2674 22.0691L15.8797 23.8641L12.099 10.4223Z",
    fill: "url(#paint4_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68164 11.7557L10.3055 24.8382L10.6974 24.2859L7.19225 11.6301L6.68164 11.7557Z",
    fill: "url(#paint5_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7335 10.5123L11.2236 10.6378L14.728 23.2921L15.3597 23.6057L11.7335 10.5123Z",
    fill: "url(#paint6_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8317 8.47844L10.6292 8.41892L10.8317 8.35941L17.8025 6.31036L17.3113 5.20055L16.8201 4.09074L10.3405 7.2496L10.1527 7.34105L10.2505 7.1654L13.6307 1.10536L12.4442 0.645906L11.2585 0.185723L9.06477 6.70522L9.00036 6.89466L8.93751 6.70522L6.74687 0.184998L5.56037 0.644454L4.3731 1.10391L7.75101 7.16467L7.84878 7.34033L7.66099 7.24887L1.1822 4.08711L0.690999 5.19692L0.199018 6.30673L7.16901 8.35868L7.37155 8.4182L7.16901 8.47772L0.198242 10.526L0.689448 11.6366L1.18065 12.7464L7.66022 9.5868L7.84801 9.49535L7.75023 9.671L4.37 15.731L5.55649 16.1912L6.74299 16.6507L8.93595 10.1312L9.00036 9.94246L9.06399 10.1312L11.2539 16.6514L12.4411 16.1919L13.6276 15.7325L10.2497 9.67172L10.1519 9.49607L10.3397 9.58753L16.8185 12.7493L17.3097 11.6402L17.8017 10.5304L10.8317 8.47844Z",
    fill: "url(#paint7_radial_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6707 9.12308L10.5078 8.99606L10.7188 9.01275L18 9.58617L17.9953 8.38563L17.9899 7.18436L10.7142 7.81149L10.5031 7.82964L10.6645 7.70189L16.247 3.29168L15.3352 2.44535L14.4242 1.59975L9.75349 6.85556L9.61769 7.00798L9.63554 6.81056L10.2486 0L8.9643 0.00508088L7.68081 0.00943592L8.35127 6.81564L8.37067 7.01307L8.23409 6.86136L3.51914 1.63967L2.61433 2.49253L1.71029 3.3454L7.32928 7.71423L7.49224 7.84052L7.28117 7.82383L0 7.25041L0.00465597 8.45168L0.0100879 9.65222L7.2866 9.02509L7.49767 9.00695L7.33549 9.1347L1.75297 13.5449L2.66477 14.3912L3.57656 15.2368L8.24728 9.98102L8.38231 9.8286L8.36446 10.026L7.75142 16.8366L9.0357 16.8322L10.3192 16.8271L9.64873 10.0217L9.62933 9.82424L9.76591 9.97522L14.4809 15.1969L15.3857 14.344L16.2897 13.4919L10.6707 9.12308Z",
    fill: "url(#paint8_radial_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 0.49054C4.31826 0.49054 0.524414 4.0399 0.524414 8.41816C0.524414 12.7964 4.31826 16.3458 8.99984 16.3458C13.6814 16.3458 17.4745 12.7964 17.4745 8.41816C17.4745 4.0399 13.6799 0.49054 8.99984 0.49054Z",
    fill: "url(#paint9_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 0.839905C4.52467 0.839905 0.898438 4.23321 0.898438 8.4184C0.898438 12.6036 4.52544 15.9969 8.99984 15.9969C13.4742 15.9969 17.1012 12.6036 17.1012 8.4184C17.1012 4.23321 13.4742 0.839905 8.99984 0.839905Z",
    fill: "url(#paint10_radial_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 2.58474L8.19031 1.20709L7.70221 2.71103L6.60417 1.52138L6.46294 3.08702L5.12357 2.13907L5.33387 3.69745L3.81291 3.0304L4.36465 4.51474L2.72885 4.15618L3.59719 5.50116L1.91716 5.4685L3.06641 6.6146L1.41664 6.91147L2.79636 7.80715L1.24902 8.41831L2.79636 9.02874L1.41664 9.92515L3.06641 10.222L1.91716 11.3681L3.59719 11.3355L2.72885 12.6804L4.36465 12.3219L3.81291 13.8062L5.33387 13.1392L5.12279 14.6975L6.46294 13.7496L6.60417 15.3152L7.70221 14.1256L8.19031 15.6295L8.99967 14.2526L9.80903 15.6295L10.2979 14.1256L11.3952 15.3152L11.5364 13.7496L12.8765 14.6975L12.6655 13.1384L14.1864 13.8062L13.6347 12.3219L15.2705 12.6804L14.4022 11.3347L16.0822 11.3681L14.9329 10.2213L16.5827 9.92515L15.203 9.02874L16.7503 8.41831L15.203 7.80715L16.5827 6.91147L14.9329 6.6146L16.0822 5.4685L14.4022 5.50189L15.2705 4.15618L13.6347 4.51474L14.1864 3.0304L12.6655 3.69817L12.8765 2.13907L11.5364 3.08702L11.3952 1.52138L10.2979 2.71103L9.80903 1.20709L8.99967 2.58474Z",
    fill: "url(#paint11_radial_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99963 2.88965C5.73424 2.88965 3.08887 5.36476 3.08887 8.41837C3.08887 11.472 5.73501 13.9478 8.99963 13.9478C12.2642 13.9478 14.9104 11.4727 14.9104 8.41837C14.9104 5.36404 12.2635 2.88965 8.99963 2.88965Z",
    fill: "#CC7127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7343 8.41822C14.7343 11.3804 12.1673 13.7815 9.00043 13.7815C5.8336 13.7815 3.2666 11.3804 3.2666 8.41822C3.2666 5.45607 5.83437 3.05499 9.00043 3.05499C12.1665 3.05499 14.7343 5.45607 14.7343 8.4175V8.41822Z",
    fill: "url(#paint12_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5797 8.41831C14.5797 11.3006 12.0818 13.6371 9.00031 13.6371C5.91883 13.6371 3.4209 11.3006 3.4209 8.41831C3.4209 5.536 5.91883 3.19952 9.00031 3.19952C12.0818 3.19952 14.5797 5.536 14.5797 8.41831Z",
    fill: "url(#paint13_linear_2924_38006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3481 8.41821C14.3481 11.1808 11.9541 13.42 9.00071 13.42C6.04727 13.42 3.65332 11.1808 3.65332 8.41821C3.65332 5.65566 6.04804 3.41644 9.00071 3.41644C11.9534 3.41644 14.3481 5.65566 14.3481 8.41821Z",
    fill: "url(#paint14_linear_2924_38006)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2924_38006",
    x1: 5.45175,
    y1: 23.1479,
    x2: 7.50325,
    y2: 15.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9CF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F8CA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F7C70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2924_38006",
    x1: 9.9694,
    y1: 20.7715,
    x2: 9.03147,
    y2: 15.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B82B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2924_38006",
    x1: 5.43944,
    y1: 15.1505,
    x2: 2.885,
    y2: 25.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2924_38006",
    x1: 8.96261,
    y1: 20.3264,
    x2: 7.41026,
    y2: 25.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2924_38006",
    x1: 12.2961,
    y1: 22.4125,
    x2: 10.2923,
    y2: 14.1865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F9CF2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F8CA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F7C70D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7C70A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2924_38006",
    x1: 8.04584,
    y1: 15.2724,
    x2: 9.89156,
    y2: 24.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2924_38006",
    x1: 12.6375,
    y1: 14.3309,
    x2: 14.4832,
    y2: 23.3358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2924_38006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.00905 8.42499) rotate(21.1879) scale(8.9125 8.49215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2924_38006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.00949 8.42878) rotate(42.8578) scale(8.71183 8.68776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2924_38006",
    x1: 8.99984,
    y1: 15.4835,
    x2: 8.99984,
    y2: 0.645144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2924_38006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.99984 8.4184) scale(8.10217 7.57849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C77C08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C87D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CB850D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D29115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DBA220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E7B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F5D440"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2924_38006",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.99967 8.41831) scale(7.72969 7.23009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DA811E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E19527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EEB837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7D142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDE049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2924_38006",
    x1: 9.00043,
    y1: 3.50138,
    x2: 9.00043,
    y2: 13.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2924_38006",
    x1: 9.00031,
    y1: 13.3439,
    x2: 9.00031,
    y2: 3.35631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2924_38006",
    x1: 8.99993,
    y1: 4.3702,
    x2: 8.99993,
    y2: 12.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FCF988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EDCD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0A831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2924_38006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.8eb77cda8a1434cd11ffda349ca8d2cd.svg";
export { ForwardRef as ReactComponent };